<mat-toolbar class="toolbarDetail" color="primary">
    <mat-toolbar-row>
      <span class=tittleToolbar>{{'MAPP-VMS-SINGLE-VISIT-DETAIL.TITLE' | translate}}</span>
      <span class="spacer"></span>
      <button class="closeViewVist" mat-icon-button (click)="onClose()"> 
          <mat-icon class="closeViewVisitIcon" aria-hidden="false" aria-label="Example heart icon">close
          </mat-icon>
      </button>
  </mat-toolbar-row>
  </mat-toolbar>